import React from 'react'

// dahsboard imports
const Dashboard = React.lazy(() => import('./pages/dashboard'));

// sensor management device threshold
const DeviceThreshold = React.lazy(() => import('./pages/manage/sensorManagement/deviceThreshold/List'));
const AddDeviceThreshold = React.lazy(() => import('./pages/manage/sensorManagement/deviceThreshold/AddEdit'));
// sensor management Feature Group
const FeatureGroup = React.lazy(() => import('./pages/manage/sensorManagement/featureGroup/List'));
const AddFeatureGroup = React.lazy(() => import('./pages/manage/sensorManagement/featureGroup/AddEdit'));
// sensor management threshold Group
const ThresholdGroup = React.lazy(() => import('./pages/manage/sensorManagement/thresholdGroup/List'));
const AddThresholdGroup = React.lazy(() => import('./pages/manage/sensorManagement/thresholdGroup/AddEdit'));
// gateway management device gateway 
const DeviceGateway = React.lazy(() => import('./pages/manage/gatewayManagement/deviceGateway/List'));
const AddDeviceGateway = React.lazy(() => import('./pages/manage/gatewayManagement/deviceGateway/AddEdit'));
//  field management field dirctionary 
const FieldDictionary = React.lazy(() => import('./pages/fieldManagement/fieldDictionary/List'));
const AddFieldDictionary = React.lazy(() => import('./pages/fieldManagement/fieldDictionary/AddEdit'));
//  field management field dirctionary 
const FieldGroup = React.lazy(() => import('./pages/fieldManagement/fieldGroup/List'));
const AddFieldGroup = React.lazy(() => import('./pages/fieldManagement/fieldGroup/AddEdit'));
// // sensor management User
// const User = React.lazy(() => import('./pages/manage/sensorManagement/User/List'));
// const AddUser = React.lazy(() => import('./pages/manage/sensorManagement/User/AddEdit'));
// sensor management Category
const Category = React.lazy(() => import('./pages/manage/sensorManagement/category/List'));
const AddCategory = React.lazy(() => import('./pages/manage/sensorManagement/category/Add'));
const Library = React.lazy(() => import('./pages/manage/sensorManagement/library/List'));
const AddLibrary = React.lazy(() => import('./pages/manage/sensorManagement/library/Add'));
const Feature = React.lazy(() => import('./pages/manage/sensorManagement/feature/List'));
const AddFeature = React.lazy(() => import('./pages/manage/sensorManagement/feature/Add'));
//device manufacturer
const DeviceManufacturer = React.lazy(() => import('./pages/manage/miscellaneous/deviceManufacturer/List'));
const AddDeviceManufacturer = React.lazy(() => import('./pages/manage/miscellaneous/deviceManufacturer/Add'));
//device tag
const DeviceTags = React.lazy(() => import('./pages/manage/miscellaneous/deviceTags/List'));
const AddDeviceTags = React.lazy(() => import('./pages/manage/miscellaneous/deviceTags/Add'));
//user management user tag
const User = React.lazy(() => import('./pages/userManagement/user/List'));
const AddUser = React.lazy(() => import('./pages/userManagement/user/AddEdit'));
//user management user tag
const UserPermission = React.lazy(() => import('./pages/userManagement/permission/List'));
const AddUserPermission = React.lazy(() => import('./pages/userManagement/permission/AddEdit'));

const DeviceModel = React.lazy(() => import('./pages/manage/miscellaneous/deviceModel/List'));
const AddDeviceModel = React.lazy(() => import('./pages/manage/miscellaneous/deviceModel/Add'));
const DeviceHWVersion = React.lazy(() => import('./pages/manage/miscellaneous/deviceHWVersion/List'));
const AddDeviceHWVersion = React.lazy(() => import('./pages/manage/miscellaneous/deviceHWVersion/Add'));
const Menu = React.lazy(() => import('./pages/administration/menuManagement/menus/List'));
const AddMenu = React.lazy(() => import('./pages/administration/menuManagement/menus/Add'));
const Module = React.lazy(() => import('./pages/administration/menuManagement/module/List'));
const AddModule = React.lazy(() => import('./pages/administration/menuManagement/module/Add'));
const Role = React.lazy(() => import('./pages/userManagement/roles/List'));
const AddRole = React.lazy(() => import('./pages/userManagement/roles/Add'));
// log management access log route
const AccessRole = React.lazy(() => import('./pages/logManagement/accessLog/List'));
// log management administrative log route
const AdministrativeRole = React.lazy(() => import('./pages/logManagement/administrativeLog/List'));
// log management device log route
const DeviceRole = React.lazy(() => import('./pages/logManagement/deviceLog/List'));

const profileEdit = React.lazy(() => import('./pages/profile/profile/AddEdit'));
const changePassword = React.lazy(() => import('./pages/profile/changePassword/AddEdit'));

const Relay = React.lazy(() => import('./pages/manage/sensorManagement/relay/List'));
const AddRelay = React.lazy(() => import('./pages/manage/sensorManagement/relay/AddEdit'));

//=========Front User========
const UserRuleList = React.lazy(() => import('./pages/front/UserRules/List'));
const FloorMap = React.lazy(() => import('./pages/front/FloorMap/pages/Map'));
const FloorList = React.lazy(() => import('./pages/front/FloorMap/pages/List'));
const FloorAddEdit = React.lazy(() => import('./pages/front/FloorMap/pages/AddEdit'));
const FrontSensorList = React.lazy(() => import('./pages/front/Sensors/List'));
const AddFrontSensor = React.lazy(() => import('./pages/front/Sensors/Add'));
const AddFrontSensorRules = React.lazy(() => import('./pages/front/Sensors/Rules/Add'));
const AddFrontSensorConfigure = React.lazy(() => import('./pages/front/Sensors/configure/Add'));

// Gateway
const Gateways = React.lazy(() => import('./pages/front/Manage/Gateways/List'));
const AddGateway = React.lazy(() => import('./pages/front/Manage/Gateways/AddEdit'));
// SMTP
const Smtp = React.lazy(() => import('./pages/front/SmtpManagement/SMTP/List'));
const AddSmtp = React.lazy(() => import('./pages/front/SmtpManagement/SMTP/AddEdit'));
// Location
const Location = React.lazy(() => import('./pages/front/Location/Location/List'));
const AddLocation = React.lazy(() => import('./pages/front/Location/Location/AddEdit'));
// Location
const UserRelay = React.lazy(() => import('./pages/front/UserRelay/List'));
const AddUserRelay = React.lazy(() => import('./pages/front/UserRelay/AddEdit'));
const SensorManagementDashboard = React.lazy(() => import('./pages/dashboard/SensorManagementDashboard'))
//Sites:
const SiteList = React.lazy(() => import('./pages/front/Sites/List'));
const SiteAddEdit = React.lazy(() => import('./pages/front/Sites/AddEdit'));


const SiteDashboard = React.lazy(() => import('./pages/front/Sites/SiteDashboard'));
const Arduinoboard = React.lazy(() => import('./components/deviceManager/arduino'));
const RuleBuilderAddEdit = React.lazy(() => import('./pages/userSensor/user-rule/AddEdit.jsx'));
const Sessionspage = React.lazy(() => import('./pages/KD/SessionsSingleDevicepage.js'));
const PatientSessionsWithDoctors = React.lazy(() => import('./pages/KD/PatientSessionsWithDoctorsPage.js'));
const SessionsPage = React.lazy(() => import('./pages/KD/DC.js'));
const NotificationList = React.lazy(() => import('./pages/Notification/NotificationList'));

const EmailAddEdit = React.lazy(() => import('./pages/Notification/email/EmailAddEdit'));
const SmsAddEdit = React.lazy(() => import('./pages/Notification/sms/SmsAddEdit'));
const TelegramAddEdit = React.lazy(() => import('./pages/Notification/telegram/TelegramAddEdit'));
const WhatsAppAddEdit = React.lazy(() => import('./pages/Notification/whatsapp/WhatsAppAddEdit.jsx'));
const PushAddEdit = React.lazy(() => import('./pages/Notification/other/OtherChannelAddEdit'));
const WebhookAddEdit = React.lazy(() => import('./pages/Notification/webhook/WebhookAddEdit.jsx'));

//minew
const DataFieldsList = React.lazy(() => import('./pages/minew/systemSetting/DataFieldsList.js'));
const StoreProductList = React.lazy(() => import('./pages/minew/Store/storeProduct.js'));


//=========Front User========

const routes = [
    { path: '/front/userSensor/rule/builder', name: 'opta rule', element: RuleBuilderAddEdit },
    // dashboard routes
    { path: '/dashboard', name: 'Dashboard', element: Dashboard },
    // sensor management device threshold routes
    { path: '/manage/sensor-management/device-threshold-values', name: 'Device Threshold', element: DeviceThreshold },
    { path: '/manage/sensor-management/add-threshold-values', name: 'Add Device Threshold', element: AddDeviceThreshold },
    // sensor management feature group routes
    { path: '/manage/sensor-management/feature-group', name: 'Feature Group', element: FeatureGroup },
    { path: '/manage/sensor-management/add-feature-group', name: 'Add Device Threshold', element: AddFeatureGroup },
    // sensor management threshold group routes
    { path: '/manage/sensor-management/threshold-group', name: 'Threshold Group', element: ThresholdGroup },
    { path: '/manage/sensor-management/add-threshold-group', name: 'Add Threshold Group', element: AddThresholdGroup },
    // gateway management device gateway routes
    { path: '/manage/gateway-management/device-gateway', name: 'Device Gateway', element: DeviceGateway },
    { path: '/manage/gateway-management/add-device-gateway', name: 'Add Device Gateway', element: AddDeviceGateway },
    // field management field dictionary routes
    { path: '/field-management/field-dictionary', name: 'Field Dictionary', element: FieldDictionary },
    { path: '/field-management/add-field-dictionary', name: 'Add Field Dictionary', element: AddFieldDictionary },
    // field management field group routes
    { path: '/field-management/field-group', name: 'Field Group', element: FieldGroup },
    { path: '/field-management/add-field-group', name: 'Add Field Group', element: AddFieldGroup },

    { path: '/manage/sensor-management/categories', name: 'Categories', element: Category },
    { path: '/manage/sensor-management/add-category', name: 'Add Category', element: AddCategory },

    { path: '/manage/sensor-management/library', name: 'Categories', element: Library },
    { path: '/manage/sensor-management/add-library', name: 'Add Category', element: AddLibrary },

    { path: '/manage/sensor-management/feature', name: 'Features', element: Feature },
    { path: '/manage/sensor-management/add-feature', name: 'Add Feature', element: AddFeature },

    { path: '/manage/miscellaneous/device-manufacturer', name: 'Device Manufacturer', element: DeviceManufacturer },
    { path: '/manage/miscellaneous/add-device-manufacturer', name: 'Add Device Manufacturer', element: AddDeviceManufacturer },

    { path: '/manage/miscellaneous/device-tags', name: 'Device Tags', element: DeviceTags },
    { path: '/manage/miscellaneous/add-device-tags', name: 'Add Device Tags', element: AddDeviceTags },

    //Device dashboard
    {
        path: '/sensor-dashboard/:sensorType/:deviceId',
        name: "Device Dashboard",
        element: SensorManagementDashboard
    },

    // user management User routes
    { path: '/user-management/user', name: 'User', element: User },
    { path: '/user-management/add-user', name: 'Add User', element: AddUser },
    // user management permission routes
    { path: '/user-management/user-permission', name: 'User', element: UserPermission },
    { path: '/user-management/add-user-permission', name: 'Add User', element: AddUserPermission },
    // Device Model
    { path: '/manage/miscellaneous/device-model', name: 'Device Model', element: DeviceModel },
    { path: '/manage/miscellaneous/add-device-model', name: 'Add Device Model', element: AddDeviceModel },
    // Device HW Version
    { path: '/manage/miscellaneous/device-hw-version', name: 'Device HW Version', element: DeviceHWVersion },
    { path: '/manage/miscellaneous/add-device-hw-version', name: 'Add Device HW Version', element: AddDeviceHWVersion },
    // Menu 
    { path: '/administration/menuManagement/menus', name: 'Menu', element: Menu },
    { path: '/administration/menuManagement/add-menu', name: 'Add Menu', element: AddMenu },
    // Module
    { path: '/administration/menuManagement/module', name: 'Module', element: Module },
    { path: '/administration/menuManagement/add-module', name: 'Add Module', element: AddModule },
    // User Role
    { path: '/administration/userManagement/role', name: 'Role', element: Role },
    { path: '/administration/userManagement/add-role', name: 'Add Role', element: AddRole },
    // log management access log route
    { path: '/log-management/access-log', name: 'Access Log', element: AccessRole },
    // log management administrative log route
    { path: '/log-management/administrative-log', name: 'Administrative Log', element: AdministrativeRole },
    // log management device log route
    { path: '/log-management/device-log', name: 'Device Log', element: DeviceRole },

    { path: '/profile/edit-profile', name: 'Profile update', element: profileEdit },
    { path: '/profile/change-password', name: 'Profile update', element: changePassword },

    { path: 'manage/sensor-management/relay', name: 'Relay', element: Relay },
    { path: 'manage/sensor-management/relay/add-edit', name: 'Relay update', element: AddRelay },

    { path: 'manage/sensor-management/all-user-rule', name: 'Rule', element: UserRuleList },

    //===========Front User Start===========


    // Rule List
    { path: '/front/userSensor/user-rule', name: 'Sensors', element: UserRuleList },
    { path: '/front/userSensor/floor-map', name: 'Sensors', element: FloorMap },

    // User Sensor List
    { path: '/front/userSensor/sensors', name: 'Sensors', element: FrontSensorList },
    { path: '/front/userSensor/add-sensor', name: 'Add Sensor', element: AddFrontSensor },
    { path: '/front/userSensor/ruels/add-sensor', name: 'Add Sensor Rules', element: AddFrontSensorRules },
    { path: '/front/userSensor/configure/add-sensor', name: 'Add Sensor Rules', element: AddFrontSensorConfigure },


    // Gateway
    { path: '/front/manage/gateway', name: 'Role', element: Gateways },
    { path: '/front/manage/gateway/add-edit', name: 'Add Role', element: AddGateway },
    // SMTP
    { path: '/front/SmtpManagement/SMTP', name: 'Role', element: Smtp },
    { path: 'front/SmtpManagement/SMTP/add-edit', name: 'Add Role', element: AddSmtp },
    // Sites
    { path: '/front/sites', name: 'Sites', element: SiteList },
    { path: '/front/sites/add-edit', name: 'Sites', element: SiteAddEdit },
    { path: '/front/location', name: 'Role', element: Location },
    { path: 'front/location/add-edit', name: 'Add Role', element: AddLocation },
    // Location
    { path: '/front/userSensor/floor-list', name: 'Sensors', element: FloorList },
    { path: '/floor/add-edit', name: 'Sensors', element: FloorAddEdit },
    // UserRelay
    { path: '/front/userRelay', name: 'User Relay', element: UserRelay },
    { path: '/front/userRelay/add-edit', name: 'Add User Relay', element: AddUserRelay },
    { path: '/front/userRelay/add-edit', name: 'Add User Relay', element: AddUserRelay },
    //===========Front User End===========

    //site SiteDashboard
    { path: '/site-dashboard', name: 'Site Dashboard', element: SiteDashboard },
    { path: '/device-manager', name: 'Controls', element: Arduinoboard },
    { path: '/pages/sessions', name: 'sessions', element: Sessionspage },
    { path: '/pages/sessions-doctors', name: 'sessions', element: PatientSessionsWithDoctors },
    { path: '/pages/t/sessions-doctors', name: 'sessions', element: SessionsPage },

    // ── LIST (single page with tabs) ──────────────────────────────────────────
    { path: "/front/notification", element: NotificationList  },

    // // ── EMAIL ─────────────────────────────────────────────────────────────────
    // { path: "/front/notification/email", element: NotificationList  },
    { path: "/front/notification/email/add", element: EmailAddEdit  },

    // // ── SMS ───────────────────────────────────────────────────────────────────
    // { path: "/front/notification/sms", element: NotificationList  },
    // { path: "/front/notification/sms/add", element: SmsAddEdit  },

    // // ── PUSH ──────────────────────────────────────────────────────────────────
    // { path: "/front/notification/push", element: NotificationList  },
    // { path: "/front/notification/push/add", element: PushAddEdit  },

    // // ── TELEGRAM ──────────────────────────────────────────────────────────────
    // { path: "/front/notification/telegram", element: NotificationList  },
    { path: "/front/notification/telegram/add", element: TelegramAddEdit  },

    // // ── WHATSAPP ──────────────────────────────────────────────────────────────
    // { path: "/front/notification/whatsapp", element: NotificationList  },
    // { path: "/front/notification/whatsapp/add", element: WhatsAppAddEdit  },

    // // ── WEBHOOK ───────────────────────────────────────────────────────────────
    // { path: "/front/notification/webhook", element: NotificationList  },
    // { path: "/front/notification/webhook/add", element: WebhookAddEdit  },
    { path: "/front/data-fields", element: DataFieldsList  },
    { path: "/front/storeProduct", element: StoreProductList  }

]
export default routes
